import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    primary: {
      main: "#70259B",
      active: "#D100C9",
    },
    shades: {
      white: "#FFFFFF",
    },
    navyBlue: {
      500: "#0F4C5C",
    },
  },
});

export default theme;
